import React, { useEffect, useContext, useState, useRef } from 'react'
import { View, Text, Pressable } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import styles from '../../modals/TermsAndConditionsStyles'

import { SafeAreaInsetsContext } from 'react-native-safe-area-context'
import theme from '../../../../theme'
import { CheckIcon } from 'phosphor-react-native'
import { getLanguage } from '../../../components/appBar/context/LocalizationContext'
import { getAlert } from '../../../components/appBar/context/AlertsContext'
import { useNavigation } from '@react-navigation/native'
import { PostsServices } from '../../../../database/posts.database'
import { TrackingServices } from '../../../../database/tracking.database'
import { getAuthToken } from '../../..//utils/functions.utils'
import { ASYNC_STORAGE_KEYS } from '../../../components/stores/constants/constants.storage'
import { StorageAdapter } from '../../../utils/AsyncStorage'
import { useTermsAndConditionsStore } from '../../../redux/zustand/termsAndContionsStore'
import { getConection } from '../../../components/appBar/context/HeaderContext'
import { apiUrl } from '../../../config/config'

export const TermsAndConditionsScreen = ({ route }) => {
    const { termsText, prevVersion, innerText } = route?.params

    const { setAlert } = getAlert()
    const { languageFile } = getLanguage()
    const insets = useContext?.(SafeAreaInsetsContext) || null
    const bottomSpace = Math.max(Number(insets?.bottom || 0), 8)
    const [check, setCheck] = useState(false)
    const [sending, setSending] = useState(false)
    const sendingRef = useRef(false)

    const navigation = useNavigation()
    const innerTTCCText =
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sed elit nec neque bibendum suscipit facilisis eu tortor. Aliquam ut aliquam sapien. Sed feugiat ligula metus, id rutrum ligula posuere non. Etiam pretium dolor dictum tincidunt dictum. Sed sodales eu ipsum ut porttitor. Curabitur fermentum ex et turpis faucibus, eu sodales ipsum tempus. Morbi porttitor odio et hendrerit sodales. Aliquam erat volutpat. Curabitur nunc lacus, consequat sit amet posuere at, vehicula malesuada mauris. Proin varius aliquet nulla eu posuere. Praesent pulvinar vehicula suscipit. Etiam maximus eleifend odio, et tempus dui posuere porta. Praesent et orci sodales, maximus est et, condimentum elit. Sed sit amet hendrerit tellus. Mauris sed quam et neque tincidunt cursus sed a mi. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc at augue nec quam viverra mattis. Quisque efficitur ante mi, a dignissim massa gravida eu. Aenean sit amet ligula maximus odio euismod vehicula volutpat et justo. Sed non metus vel justo consectetur sagittis. Vivamus lobortis bibendum viverra. Vivamus malesuada porttitor vehicula. Suspendisse ornare pretium lectus non tincidunt. Fusce eget arcu augue. Nulla condimentum vehicula mi, non vehicula mi pharetra eu. Interdum et malesuada fames ac ante ipsum primis in faucibus. Aliquam bibendum finibus congue. Praesent sed vehicula eros, sed finibus leo. Morbi risus est, scelerisque sed mi quis, vulputate tempor lorem. Curabitur porttitor enim fermentum laoreet posuere. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Pellentesque sit amet nunc eget nulla maximus egestas at et nisi. Nam eget vehicula dolor. In vitae sapien volutpat, consequat leo eget, congue mauris. Nulla tempus arcu eu arcu consectetur, vitae placerat lectus pellentesque. Proin tincidunt massa et pretium egestas. In pulvinar scelerisque congue. Fusce eget mauris at massa tempor commodo vel sed mi. Mauris scelerisque metus nunc, eget molestie justo venenatis et. Donec facilisis commodo fringilla. Duis varius tortor mauris, ut laoreet lectus tincidunt sit amet. Vivamus pharetra dapibus risus, vel aliquet metus dignissim id. Proin ante urna, cursus at eros vitae, pulvinar posuere dui. Nunc a venenatis neque. Integer porttitor sem fringilla, aliquam magna ut, viverra dui. Vivamus quam erat, aliquet ut dignissim id, sodales a dui. Quisque quis neque magna. Donec purus nulla, fringilla id rhoncus ac, placerat a leo. Quisque hendrerit eros et arcu congue, vitae semper augue laoreet. Donec iaculis ante in justo egestas, ut convallis arcu aliquam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in porta mauris. Mauris sollicitudin, orci vitae fringilla bibendum, metus erat sodales tortor, eu lacinia neque arcu sit amet est. Suspendisse ac risus viverra, pretium eros nec, commodo lacus. Praesent in ligula id lacus dapibus aliquet. Donec arcu lorem, facilisis vitae tortor non, congue ornare dolor. Pellentesque ante enim, varius vel lacinia sit amet, ullamcorper quis leo. Fusce sed turpis efficitur, maximus diam nec, suscipit nisi. Phasellus at egestas dolor. Nam dignissim nec nisl in tempor. Mauris tristique laoreet quam ac consectetur. Quisque ultrices mi ex, et scelerisque nibh laoreet quis. Fusce a dolor quis turpis laoreet cursus eu mattis augue. Nullam ut vehicula nisl, et sagittis diam. Integer tempus congue lacus eu iaculis. Vestibulum semper eu ex sit amet aliquet. In tellus augue, posuere in consectetur nec, maximus non felis. Curabitur pulvinar diam a neque maximus lobortis. Sed et tincidunt diam. In aliquam congue orci at feugiat. Donec volutpat sed nisi in efficitur. Cras non magna metus.'
    const acceptTermsAndConditions = useTermsAndConditionsStore(
        (state) => state.acceptTerms,
    )
    const { isConnected, hasInternet } = getConection()

    // Obtener las primeras tres palabras del texto

    let title = ''

    // Obtener el índice del primer carácter después de las primeras tres palabras
    let startIndex = ''

    // El texto restante después de las primeras tres palabras
    let description = ''

    if (termsText != undefined && termsText.length > 0) {
        title = termsText.split(/\s+/).slice(0, 3).join(' ')

        // Obtener el índice del primer carácter después de las primeras tres palabras
        startIndex = termsText.indexOf(title) + title.length

        // El texto restante después de las primeras tres palabras
        description = termsText.substring(startIndex).trimStart()
    }

    const acceptTerms = async (version) => {
        if (sendingRef.current === true) return
        setSending(true)
        sendingRef.current === true
        try {
            let user_id = null
            try {
                const user = await PostsServices.getUser()
                user_id = user && user['_id'] ? String(user['_id']) : null
            } catch {}
            if (user_id) {
                try {
                    TrackingServices.addTracking(
                        user_id,
                        'accept_terms_and_conditions',
                        'terms_and_conditions_acceptances',
                    )
                } catch {}
            }
            let data
            let fetch_error = false

            if (!isConnected || !hasInternet)
                throw new Error(
                    'Necesitas conexion a internet para aceptar los términos y condiciones',
                )

            const authToken = await getAuthToken('posts_ttcc_accept')
            const response = await fetch(`${apiUrl}/accept_terms_and_conditions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken || '',
                    version: String(version ?? ''),
                },
            })
            // console.log('RESPONSE ACCEPTANCE ==>', JSON.stringify(response))
            if (!response.ok) {
                console.log('Error de response', response)
                data = { status: 0 }
                fetch_error = true
            }

            if (fetch_error) throw new Error('Fallo de servicio')

            data = await response.json()

            if (
                data?.single &&
                data.status == 1 &&
                data.single.terms &&
                data.single.terms.accept == true
            ) {
                acceptTermsAndConditions()
                setAlert(
                    'Términos aceptados',
                    'white',
                    'check-circle',
                    'rgba(32, 201, 151, 0.9)',
                    true,
                    false,
                    'Feather',
                    22,
                )
                navigation.goBack()
                try {
                    const ver = String(version ?? data?.single?.version ?? '')
                    if (ver) {
                        const globalKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_ACCEPTED}:global:${ver}`
                        await StorageAdapter.setItem(globalKey, 'true')
                    }
                } catch {}
            }
        } catch (err) {
            console.error('TTCC', 'acceptTerms error (posts)', err)
            setAlert(
                'Ocurrió un error',
                'white',
                '',
                'rgba(44, 46, 45, 0.9)',
                true,
                false,
                'Feather',
                22,
            )
        } finally {
            setSending(false)
            sendingRef.current = false
        }
    }
    const hasInnerText =
        innerText != null && innerText != undefined && innerText.trim() != ''
    const disableSendButton = !check || sending
    return (
        <View style={{ flex: 1, width: '100%' }}>
            <ScrollView
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: bottomSpace + 12 }}
                nestedScrollEnabled={true}
            >
                <View style={styles.container}>
                    <Text style={styles.title}>{title}</Text>
                    <Text style={styles.description}>{description}</Text>
                </View>
                <View style={styles.spacer}></View>
            </ScrollView>

            <View
                style={[
                    styles.buttonContainer,
                    { paddingBottom: bottomSpace, backgroundColor: 'white' },
                ]}
                pointerEvents='box-none'
            >
                <View
                    style={{
                        flexDirection: 'row',
                        marginBottom: 16,
                        alignItems: 'center',
                    }}
                >
                    <Pressable
                        onPress={() => setCheck((c) => !c)}
                        style={{
                            width: 24,
                            height: 24,
                            borderColor: theme.colors.darkGray,
                            borderWidth: !check ? 1 : 0,
                            borderRadius: 4,
                            backgroundColor: !check
                                ? undefined
                                : theme.colors.colorPrimary,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {check && <CheckIcon size={18} color='white' />}
                    </Pressable>
                    <Text
                        style={{
                            flexShrink: 1,
                            marginStart: 12,
                            color: theme.colors.darkGray,
                            fontSize: 14,
                        }}
                    >
                        {
                            'Al hacer clic en "Aceptar", usted declara haber leído y aceptado los '
                        }
                        <Text
                            disabled={!hasInnerText}
                            onPress={() => {
                                if (!hasInnerText) return
                                navigation.navigate(
                                    'TermsAndConditionsDetailScreen',
                                    { text: innerText },
                                )
                            }}
                            style={[
                                hasInnerText && {
                                    color: 'blue',
                                    textDecorationLine: 'underline',
                                },
                            ]}
                        >
                            términos y condiciones.
                        </Text>
                    </Text>
                </View>
                <Pressable
                    onPress={() => acceptTerms(prevVersion)}
                    disabled={disableSendButton}
                    style={[
                        styles.mainButton,
                        disableSendButton && {
                            backgroundColor: theme.colors.lightGray,
                        },
                    ]}
                >
                    <Text
                        style={[
                            styles.mainButtonText,
                            disableSendButton && { color: theme.colors.darkGray },
                        ]}
                    >
                        {languageFile.accept}
                    </Text>
                </Pressable>
            </View>
        </View>
    )
}
